import useSWR from 'insights/hooks/useSWR';
export default () => useSWR({ url: 'settings' });
